/**
 * A synchronous "probably signed in" hint for the very first paint.
 *
 * Firebase Auth restores its session asynchronously, but dist/index.html carries the prerendered
 * landing page and Hosting serves it for every URL. The inline gate that scripts/prerender-home.mjs
 * injects reads this same localStorage key (it cannot import modules) so that a signed-in user who
 * opens the bare "/" URL is not shown the landing page for the instant before auth resolves;
 * RootRoute reads it for the same reason. It is only a hint: if it is stale the visitor sees a
 * short neutral spinner and then the real state, never the wrong page.
 */
export const AUTH_HINT_KEY = 'rr:auth-hint';

export function readAuthHint(): boolean {
  try {
    return localStorage.getItem(AUTH_HINT_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeAuthHint(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(AUTH_HINT_KEY, '1');
    else localStorage.removeItem(AUTH_HINT_KEY);
  } catch {
    // Storage unavailable (privacy mode) — the hint is optional.
  }
}
